/**
* vue 全局过滤器
*
* @author yangkun-QQ-58740563-foxkeeper-yangkun@xforceplus.com
* @link
* @create 2018-03-15
*/

import dateFormat from 'vux/src/tools/date/format.js'


export default {

invoiceTypeFormat(val){
var rel = "";
switch (val) {
case 'ce':
rel = '增值税电子普通发票';
break;
case 's':
rel = '增值税专用发票';
break;
case 'ce':
rel = '增值税电子普通发票';
break;
default:
rel = '';
break;
}
return rel;
},
/** 格式化金额
* @param  value
*/
amountFormat(value){
var html,_val;
value = Number(value).toFixed(2);
if(value==0){
value=0;
return html = "￥0.00";
}else if(value.split('.')[1].substring(1)==0){
value = Number(value).toFixed(2);
}
_val = value.split('.');
return html = '￥'+ value;
},

/** 格式化时间为指定格式
* @param  time 时间字符串
* @param  fmt  格式
*/
formatDateTime(time, fmt) {
if (time) {
time = time.replace(/-/g, '/');
return dateFormat(time, fmt);
} else {
return time;
}
},

/** 格式化标题   控制字数
* @param  value 文本
* @param  leng  保留长度
*/
formatTitle(value, leng) {
var rel = '';
if (value && value.length > leng) {
rel = value.substr(0, leng);
} else {
rel = value;
}
return rel;
},


/** 格式化  格式化时间  友好格式  如 刚刚 一分钟前
* @param  time 时间 字符串
* @param  fmt  要格式化的格式
*/

friendlyTime(time, fmt) {
var date = (typeof time === 'number') ? new Date(time) : new Date((time || '').replace(/-/g, '/'));
var diff = (((new Date()).getTime() - date.getTime()) / 1000);
var dayDiff = Math.floor(diff / 86400);

var isValidDate = Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date.getTime());

if (!isValidDate) {
console.error('not a valid date')
}
const formatDate = function (date) {
var today = new Date(date);
var year = today.getFullYear();
var month = ('0' + (today.getMonth() + 1)).slice(-2);
var day = ('0' + today.getDate()).slice(-2);
var hour = today.getHours();
var minute = today.getMinutes();
var second = today.getSeconds();
return `${year}-${month}-${day} ${hour}:${minute}:${second}`
};

if (isNaN(dayDiff) || dayDiff < 0 || dayDiff >= 31) {

return new Date(date).format(fmt);
}

return dayDiff === 0 && (
diff < 60 && '刚刚' ||
diff < 120 && '1分钟前' ||
diff < 3600 && Math.floor(diff / 60) + '分钟前' ||
diff < 7200 && '1小时前' ||
diff < 86400 && Math.floor(diff / 3600) + '小时前') ||
dayDiff === 1 && '昨天' ||
dayDiff < 7 && dayDiff + '天前' ||
dayDiff < 31 && Math.ceil(dayDiff / 7) + '周前'
},


/**格式化 文档类型 简称
* @param  docmentType 文档类型编号
* @param  $t i10n国际化对象
*/
formatDocumentShortName(docmentType, $t) {
var $self = this;
if (!docmentType) return "";
var rel = '<span class="document-mark warning">';
switch (docmentType) {
case '10001001':
rel += '专';
break;
case '20001001':
case '20001002':
rel += '普';
break;
case '30001001':
rel += '电';
break;
case '30001002':
rel += '行';
break;
case '40001001':
rel += '卷';
break;

case '50001001':
rel += '机';
break;

case '50001009':
rel += '飞';
break;

case '50001010':
rel += '火';
break;
case '50001011':
rel += '交';
break;
case '50001012':
rel += '信';
break;

case '50001013':
rel += '定';
break;
default:
rel = '';
break;
}
rel += '</span>';
return rel;
},

/**格式化 发票类型 简称
* @param  invoiceType 发票类型编号
* @param  $t i10n国际化对象
*/
formatInvoiceTypeShortName(invoiceType, $t) {
var $self = this;
if (!invoiceType) return "";
var rel = '<span class="document-mark normal">';
switch (invoiceType) {
case 's':
rel += '专';
break;
case 'c':
rel += '普';
break;
case 'ce':
rel += '电';
break;
case 'ju':
rel += '卷';
break;

case 'v':
rel += '机';
break;
default:
rel = '';
break;
}
rel += '</span>';
return rel;
}
}



// WEBPACK FOOTER //
// ./src/common/js/filter.js